import React, {useCallback, useMemo} from 'react'
import loadable from '@loadable/component'
import {useLeapDrawer, useIsLeapDrawerOpen, preloadLeapDrawer} from '../drawer'

const ContentDrawerBody = loadable(() => import('./internal'))

export const preloadContentDrawer = () =>
    Promise.all([preloadLeapDrawer(), ContentDrawerBody.preload()])

/**
 * Hook for opening a content drawer via the overlay manager.
 * Opens a LeapDrawer populated with CMS modules loaded from a content asset.
 *
 * @returns {{
 *   open: (params: {contentId: string, theme?: 'light'|'dark'}) => void,
 *   close: () => void,
 *   remove: () => void
 * }}
 */
export const useContentDrawer = () => {
    const {open: openDrawer, close, remove} = useLeapDrawer()

    const open = useCallback(
        ({contentId, theme} = {}) =>
            openDrawer({
                content: <ContentDrawerBody contentId={contentId} />,
                theme
            }),
        [openDrawer]
    )

    return useMemo(() => ({open, close, remove}), [open, close, remove])
}

export const useIsContentDrawerOpen = useIsLeapDrawerOpen
